import styled from 'styled-components';

export default {
    SmsBlockContainer: styled.div.attrs({ className: 'sms-block-container' })`
        width: auto;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    `,
    SmsBlockTitle: styled.h4.attrs({ className: 'sms-block-title' })`
        font-family: ToyotaText,serif;
        font-size: 15px;
        line-height: 15px;
        letter-spacing: 0.08px;
        color: #202020;
        margin: 0;
    `,
    SmsBlockInputContainer: styled.div.attrs({ className: 'sms-block-input-container' })`
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding: 5px 0;
        @media(max-width: 700px) {
            width: 100%;
        }
    `,
    SmsBlockButton: styled.button.attrs({ className: 'sms-block-button' })`
        margin-right: 10px;
        padding: 14px 20px;
        background: ${props => props.isPending ? '#F0F0F0' : props.isConfirmed ? '#FFFFFF' : '#E50000'};
        box-sizing: border-box;
        border-radius: 23px;
        font-family: Toyota Display,serif;
        font-size: 15px;
        line-height: 20px;
        height: 50px;
        letter-spacing: 0;
        color: ${props => props.isPending ? '#020202' : '#E4E4E4'};
        border: 1px solid #E4E4E4;
        outline: none;
        flex-grow: 1;
        cursor: ${props => props.isConfirmed ? 'default' : 'pointer'};
        @media(max-width: 700px) {
            flex-basis: 100%;
            max-width: 232px;
        }
        @media (min-width: 700px) {
            flex-grow: 0;
            width: 250px;
        }
        &:focus {
            // we need some styles
        }
        @media (max-width: 320px) {
            width: 100%;
            max-width: 100%;
        }
    `,
    SmsBlockInput: styled.input.attrs({ className: 'sms-block-input' })`
        background: #F0F0F0;
        border-radius: 4px;
        width: 72px;
        height: 18px;
        border: none;
        caret-color: #E50000;
        padding: 12px 10px;
        outline: none;
        flex-basis: 40%;
        max-width: 72px;
        @media (min-width: 700px) {
            width: 43px;
        }
    `,
    SmsBlockError: styled.span.attrs({ className: 'sms-block-error' })`
        font-family: Noto Sans,sans-serif;
        font-size: 18px;
        line-height: 30px;
        color: #E50000;
    `,
    TimerComponent: styled.div.attrs({ className: 'timer-component' })`
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
    TimerLoader: styled.div.attrs({ className: 'timerLoader' })`
        margin-right: 10px;
        width: 20px;
        height: 20px;
        mix-blend-mode: normal;
        opacity: 0.6;
        border: 1px solid #020202;
        border-left: none;
        border-bottom: none;
        border-radius: 100%;
        box-sizing: border-box;
        animation: 1s linear 0s normal none infinite running rotate;
        @keyframes rotate {
            0% {
                transform: rotate(0deg);
            }
              100% {
                transform: rotate(360deg);
            }
        }
    `,
};
